<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="d-flex flex-column">
    <div class="d-flex flex-row align-center pb-2">
      <v-icon small>
        mdi-paperclip
      </v-icon>
      <strong v-once class="attachments-label">{{ $t('attachments') }}</strong>
    </div>
    <div class="d-flex flex-row flex-wrap">
      <EcsEmailAttachment
        v-for="(file, index) in attachments"
        :key="index"
        :file="file"
        :file-name="file[fileName]"
        :content-type="file[contentType]"
        @attachmentClick="onAttachmentDownload"
      />
    </div>
  </div>
</template>

<script>
import EcsEmailAttachment from '@/components/ecs-email/ecs-email-attachment/EcsEmailAttachment';
export default {
  name: 'EcsEmailAttachments',
  components: { EcsEmailAttachment },
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    fileName: {
      type: String,
      default: 'fileName'
    },
    contentType: {
      type: String,
      default: 'contentType'
    }
  },
  methods: {
    onAttachmentDownload(file) {
      this.$emit('onAttachmentDownload', file);
    }
  }
};
</script>

<style scoped>
.attachments-label {
  font-size: 16px;
}
</style>
